<template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1424', '销售订单-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1423', '销售订单-明细') }}</div>
            </div>
        </div> 
        <div v-show="actitem=='two'" class="ve-list-page__body">
            <ord-two></ord-two>
        </div>
        <div v-if="actitem=='one'" class="ve-list-page__body">
            <div style=" display:flex;   background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
                <div style="min-width:1400px;display:flex;padding-top:3px">
                    <div style="width:70px">
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                    </div>
                    <div style="font-size:12px;line-height:30px; width:55px;margin-left:8px;font-weight:600">{{ $LANG('0120', '查询字段') }}</div>
                    <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px;  ">
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input ref="refinput" :placeholder="input_hold" clearable  v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px;margin-right:10px ">
                        <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                    </el-input>
                    <span style="font-weight:600;color:#409eff;font-size:12px;margin-right:10px;margin-left:15px">{{ $LANG('0944', '订单状态') }}</span>
                    <el-select @change="qryTabData"  v-model="v_isfin" size="small"  style="width:100px; " >                
                        <el-option :label="$LANG('0040', '所有记录')" value="ALL" ></el-option>
                        <el-option :label="$LANG('2004', '未完成')" value="N" ></el-option>
                        <el-option :label="$LANG('1974', '已完成')" value="Y" ></el-option>
                        <el-option :label="$LANG('2141', '异常关闭')" value="A" ></el-option>
                    </el-select> 
                    <el-dropdown @command="dropSel"   size="small" style="margin-left:15px;">
                        <el-button type="danger" size="small" style="height:31px">
                            {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown"  >
                            <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                            <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
 
                    <el-button type="primary"   icon="iconfont icon-daochu" @click="nextGen" size="mini" style="margin-left:15px;height:30px;margin-top:1px">{{ $LANG('1045', '下推应收单') }}</el-button>
                </div>
            </div> 
            <div style="width:100%" class="ve-list-page__body">
                <div class="ve-list-page__table">
                <ve-table :columns="vueCol" 
                        :table-data="tabData" 
                        :columnHiddenOption="columnHiddenOption"
                        style="margin-top:2px; "
                        :border-around="true"
                        :border-x="true" 
                        :border-y="true" 
                        :fixed-header="true"

                        row-key-field-name="IDSEQ"
                        :row-style-option="rowStyleOption"
                        :cell-style-option="cellStyleOption"
                        :max-height="tabHeight" 
                        :virtual-scroll-option="virtualScrollOption"
                        :scroll-width="0"
                        :footer-data="footerData"
                        :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                
                        :column-width-resize-option="columnWidthResizeOption"
                        :cellSelectionOption="{enable: false,}"
                        id="sale_load"
                        ref="tableRef"
                    >

                </ve-table>
                </div>
                <div style="margin-top:2px" class="ve-list-page__pagination">
                    <ve-pagination
                        :total="dataCount"
                        :page-index="pageIndex"
                        :page-size="pageSize"
                        :page-size-option="pageList"
                        @on-page-number-change="pageNumberChange"
                        @on-page-size-change="pageSizeChange"
                    />
                </div>
            </div>
            <!-- 明细资料 -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <div v-for="(gpitem,gpind) in formArr" :key="gpind" style="margin-bottom:10px;">
                        <!-- <p slot="header" style="color:#5cadff;height:14px;line-height:14px ">
                            <span style="font-weight:600;font-size:14px;color:#5cadff">{{gpitem.gpnm}} </span>        
                        </p> -->
                        <div class="one-div">
                        <span class="oneRow"> {{gpitem.gpnm}}</span>
                        </div>
                        <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                            <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                    <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input-number size="medium" :precision="item.dotnum" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                    <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                    <el-select size="medium" filterable :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                        <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                    </el-select>
                                    <el-select size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='ACTNO'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                        <el-option v-for="(item,index) in cashArr " :key="index" :label="item.ACCNM" :value="item.IDSEQ"></el-option>
                                    </el-select>
                                    <el-select size="medium" filterable v-else-if="item.key==='CLNTNO'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                        <el-row v-for="item in clntArr " :key="item.IDNO">
                                            <el-col :span="6">
                                                <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-option  :label="item.CLTYPENM" :value="item.IDNO"></el-option>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-option  :label="item.CLNTNM" :value="item.IDNO"></el-option>
                                            </el-col>
                                        </el-row>
                                    </el-select>
                
                                    <el-select  size="medium" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                        <el-row v-for="(item,index) in empArr " :key="index">
                                            <el-col :span="6">
                                                <el-option  :label="item.EMPNO" :value="item.USERNM"></el-option>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-option  :label="item.DEPTNM" :value="item.USERNM"></el-option>
                                            </el-col>
                                            <el-col :span="7">
                                                <el-option  :label="item.USERNM" :value="item.USERNM"></el-option>
                                            </el-col>
                                        </el-row>
                                    </el-select>
                                    <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                    </div>
                    <div class="one-div"> <span class="oneRow"> {{ $LANG('1018', '销售明细') }} </span>
                        <el-link  @click="saleAdd" :disabled="saveFlag" style="margin-left:20px; color:#cc0000;font-size:12px" size="mini" icon="iconfont icon-xinzeng"> {{ $LANG('0087', '新增明细') }} </el-link>
                        
                    </div>             
                    <el-table  :data="dtlData" 
                        border                            
                        size="small"
                        ref="refsale"
                        :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                        :style="{'margin-top':'-8px'}"
                        cell-class-name="clearPadding"
                        :row-class-name="tabRowClass"
                        :height="350" 
                        show-summary
                        :summary-method="getSummary"
                        class="custom-table-border"
                        highlight-current-row
                        @row-click="dtlClick" > 
                        <el-table-column :label="$LANG('0310', '序号')" width="60" type="index" ></el-table-column>
                            <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :sortable="item.edcss!=='checkbox'&& item.sortable=='N'"
                                :align="item.align"                                                        
                                :min-width="item.width">
                                <template slot="header">
                                    <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                                    <span v-else >{{item.title}}</span>
                                </template>
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else-if="item.key=='ORDTY'" v-text="scope.row['ORDTYNM']"></span>
                                        <span v-else-if="item.key=='MATTY'" v-text="scope.row['CMATTY']"></span>
                                        <span v-else-if="item.key=='RATE'" v-text="scope.row['RATENM']"></span>
                                        <span v-else v-text="scope.row[item.key]"></span>
                                    </span>
                                    <span v-else >                    
                                        <el-select :ref="'pos'+scope.$index+item.key" size="mini" v-if="item.key=='ORDTY'" v-model="scope.row[item.key]">
                                            <el-option v-for="(item,index) in tyArr" :label="item.CNAME" :value="item.CODE" :key="index"></el-option>
                                        </el-select>
                                        <el-select :ref="'pos'+scope.$index+item.key" v-else-if="item.key==='RATE'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                            <el-option v-for="(item,index) in taxArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                        </el-select>
                                        <el-select :ref="'pos'+scope.$index+item.key" v-else-if="item.key==='MATTY'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                            <el-option v-for="(item,index) in matArr" :key="index" :label="item.CNAME" :value="item.SUBNO"></el-option>
                                        </el-select>
                                        <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                        <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key)" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <el-date-picker  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                        
                                        <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                                    </span>
                                </template>
                            </el-table-column>                
                        <el-table-column
                            fixed="right"
                            :label="$LANG('0330', '操作')"
                            align="center"
                            width="75">
                            <template slot-scope="scope">
    
                                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="saveFlag" @click="perDel(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span> </el-link>
                            </template>
                        </el-table-column>                        
                    </el-table>           
                    <div class="one-div"> <span class="oneRow"> {{ $LANG('0968', '费用明细') }} </span>
                        <el-link  @click="feeAdd" :disabled="saveFlag" style="margin-left:20px; color:#cc0000;font-size:12px" size="mini" icon="iconfont icon-xinzeng"> {{ $LANG('0182', '新增费用') }} </el-link>
                    </div> 
                    <el-table  :data="feeData" 
                        border                            
                        size="small"
                        ref="reffee"
                        :style="{'margin-top':'-8px'}"
                        :cell-style="{padding:'2px'}"
                        :height="160" 
                        class="custom-table-border"
                        highlight-current-row> 
                        <el-table-column  v-for="(item,index ) in feeCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.key!=='RN'&&item.edcss!=='checkbox'&& item.sortable=='N'"
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column
                            fixed="right"
                            :label="$LANG('0330', '操作')"
                            align="center"
                            width="150">
                            <template slot-scope="scope">
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="saveFlag" @click="feeEdit(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:2px;">{{ $LANG('1639', '编辑') }}</span> </el-link>
                                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="saveFlag" @click="feeDel(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span> </el-link>
                            </template>
                        </el-table-column>                        
                    </el-table>
                    <div class="one-div">
                        <span class="oneRow">{{ $LANG('0516', '上传附件') }}</span>
                    </div> 
                    <div style="display:flex" >
                        <Upload
                        
                            ref="upload"
                            name="upfile"
                            :data="uploadData"
                            :show-upload-list="false"
                            :before-upload="beforeImgFile"
                            :on-success="successImgFile"
                            :with-credentials="true"                            
                            :format="['jpg','jpeg','png','gif','tiff','pdf' ]"
                            :max-size="8192"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            type="drag"
                            :on-progress="handleProgress"
                            :action="uploadUrl"
                            style="display: inline-block;width:200px; ">                           
                            <div style="padding: 1px 0;width:200px;height:150px;">
                                <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                            </div>                                                       
                        </Upload> 
                        <div style="display:flex; "  >
                            <div v-for="(item,index) in imgData" :key="index" style="margin-left:30px">  
                                <div v-if="item.FILEPATH&&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:180px;height:140px;border:1px solid #e8eaec;overflow-y:hidden">
                                    <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                </div>
                                <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:180px;height:140px;margin-right:30px;" :src="item.FILEPATH"/> 
                                <div style="height:25px;background:#e8eaec;width:180px; display:flex;justify-content:space-between">
                                    <el-link :disabled="saveFlag" :underline="false" style=" font-size:12px" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                    <el-link v-if="item.FILEPATH.lastIndexOf('pdf')>-1" :underline="false" style="margin-right:2px;font-size:12px" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <span :style="stfgColor">
                            <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                        </span>
                        <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                        <el-button   @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                    </span>
                </div>
            </el-dialog>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
                </span>
            </el-dialog>
 
            <!-- 费用资料框 -->
            <el-dialog  v-dialogDrag :visible.sync="feeWin"  :width="dlgWidth" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{perFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
                </div>
                <Form :model="feeRow" :label-width="120"  label-position="right" inline  >  
                    <span v-for="(item,index) in feeCol" :key="index" >
                        <FormItem  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'"> 
                            <template slot="label"><span v-if="item.key=='FEENO'" style="color:red;margin-right:6px;">*</span>{{item.title}}</template>                 
                            <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="feeRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                            <el-input-number @change="feeAmt(item.key)" controls-position="right" :precision="item.dotnum" :disabled="saveFlag||item.disabled==='Y'?true:false"  v-else-if="item.edcss==='number'" v-model="feeRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-input type="text" v-else-if="item.key==='ACNO'" disabled v-model="feeRow[item.key]">
                                <div slot="append">
                                    <el-button @click="accChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                </div>
                            </el-input>
                            <el-select v-else-if="item.key==='RATE'"  @change="feeAmt(item.key)" v-model="feeRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in taxArr" :key="index" :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </el-select>
                            <el-select filterable @change="selChg(item.key,feeRow[item.key],comboArr[item.key])" :disabled="saveFlag" v-else-if="item.key==='FEENO'" v-model="feeRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="feeRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form> 
                <span slot="footer"  >
                    <el-button type="info" size="small" @click="feeWin = false" style="margin-right:40px;">{{ $LANG('0132', '取 消') }}</el-button>
                    <el-button type="primary" size="small" @click="feeSure">{{ $LANG('1638', '确 定') }}</el-button>
                </span>
            </el-dialog>
    
            <!-- 科目选择  -->
            <el-dialog v-dialogDrag :visible.sync="accWin" width="900px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0898', '科目选择') }}</span>
                </div> 
                <div style="height:87vh;overflow-y:auto">
                    <subJect @child-subject="accOk"  ></subJect>
                </div>
            </el-dialog>
            <!-- 引用报表 -->
            <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
                </div> 
                <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
            </el-dialog> 
            <!-- report preview -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>
            <!-- 引用选择框 -->
            <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
                </div> 
                <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
            </el-dialog>
            <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中...') }}</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
            <!-- 变更物料类型--> 
            <el-dialog v-dialogDrag :visible.sync="stfgWin"  width="550px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0647', '变更状态') }}</span>
                </div>
                <div style="line-height:40px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0944', '订单状态') }}</div>
                    <el-select   v-model="v_stfg" :placeholder="$LANG('1664', '请选择')" size="medium" style="width:100%">
                       <el-option :label="$LANG('1974', '已完成')" value="Y"  ></el-option>
                       <el-option :label="$LANG('2004', '未完成')" value="N"  ></el-option>
                       <el-option :label="$LANG('2141', '异常关闭')" value="A"  ></el-option>
                    </el-select>

                </div>
                <div style="line-height:40px;height:40px;font-size:12px;font-weight:600;display:flex;margin-top:20px;margin-bottom:15px">
                    <div style="font-size:12px;width:100px">{{ $LANG('0294', '备注') }}</div>
                    <el-input  type="text"  v-model="v_rmk" style="width:100%"></el-input>
                    
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="stfgWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="primary" icon="iconfont icon-chenggong"  size="small" @click="stfgSure" style="margin-right:12px;">{{ $LANG('1638', '确定') }}</el-button>
                    </span>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
        </div>
    </div>  
</template>
<script>
import ordTwo from './sale_ord_two.vue' 
import subJect from '../datamgt/subject.vue'
import pubWin from '../datamgt/pubwin.vue'  
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
import repWin from '../datamgt/repWin.vue' 
import { startWorkflowInstance } from '@/utils/workflowDesigner.js'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"sale_ord",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '123',
            fieldIdseq: '123',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SMPNO'],
            syncMainColumnSettings: true,
        })
    ],
    data () {
        return {
            loadWin:false,
            v_stfg:'N',
            v_rmk:'',
            stfgWin:false,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            tyArr:[],
            matWin:false,
            smpWin:false,
            clntArr:[],
            drawer:false,
            perFlag:'create',
            dtlRow:{},
            saveFlag:false,
            input_hold:this.$LANG('1718', '请输入查询的值'),
            promptWin:false,
            v_row:{},
            accWin:false,
            prompt:'',
            stfgCss:'',
            dtlWin:false,
            stfgColor:'',
            mainRow:{},
            clntWin:false,
            taxArr:[],
            cashArr:[], // 
            v_sel:'N',

            v_isfin:'N',
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
 
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            repWin:false,
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            othBool:false,
            delArr:[],  
            rowIndex:'-1',
            v_url: 'xuper_auth/getTableRecMany', //api请求路径
            v_formurl: 'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
     
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            empArr:[],
            dataCount:0,
            operArr:[],
 
            v_index:'',
            goPage:'',
            notNull:[],
            pageIndex:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [50,500,1000],
            pageSize: 50,
            prodCol:[],
            v_batRow:{},
            feeWin:false,
            feeRow:{},
            feeData:[],
            feeFlag:'create',
            feeIndex:'',
            delFee:[],
            feeCol:[],
            saveTag:true,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            btnWin:false,
            v_tabRow:{},
            v_tabIndex:'',
            matArr:[],
            chkIndex: 0,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            delImg:[],
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            initCol:[],
            footerData:[],
            actitem:'one',
        }
    },
    mounted () { 
        this.showkey()
        getBaseData(this.v_url ,'userno',this.v_username,'frmidseq','123','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base',' order by sortby').then(res=>{
            this.taxArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','399846','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.matArr =res.result
        }) 
        //用户表单新增、编辑、审核、作废权限 :frmid:123 ID
        getBaseData(this.v_url ,'userno',this.v_username,'frmidseq','123','v_sys_user_priv','').then(res=>{           
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //下推
                this.cancelBool=true
            }if (row.ISOTH=='Y'){ //仅看自己的记录
                this.othBool=true
            }
            //查询数据
            this.qryTabData()
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'isout','N','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.cashArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl, 'v_sys_form_fld','idseq','123','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_clnt',' order by cltype').then(res=>{
            this.clntArr =res.result
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url, 'v_sys_form_fld','idseq','123','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 195) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 455) + 'px';
        },
    },
    components: {
        ordTwo,
        subJect,
        repWin,
        pubWin ,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#sale_load"),
                name: "wave",
            })
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        batStfg(row){
            this.stfgWin =true         
            this.v_batRow= JSON.parse(JSON.stringify(row))
        },
        chkChg(){
            if (this.v_row['SEL'] =='Y'){
                this.tabData.filter(item=>item.STFG=='Y').forEach((item,index)=>{
                    item['SEL'] ='Y' 
                })
            }else{
                this.tabData.forEach((item,index)=>{
                    item['SEL'] ='N' 
                })
            }            
        },
        nextGen(){
            const v_len =this.tabData.filter(item=>item['SEL']=='Y') 
            //const v_arr  =Array.from(new Set(v_len.map(item=>item.CLNTNM))) 
            if (v_len.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('1774', '请选择要下推的记录')
            }else{                
                this.$confirm( this.$LANG('1616', '你确定要下推生成销售应收单吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{                    
                    let v_idseqArr =v_len.map(item=>Object.assign({IDSEQ:item.IDSEQ}))
                    this.$axios({
                        method: 'post',
                        url:  'xuper_auth/mrp_Calc' ,
                        data: {p_json:JSON.stringify(v_idseqArr), corpid:this.v_corpid, p_action:'SALE_RECEIVE' },
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$notify({
                                title: this.$LANG('1441', '成功'),
                                message: this.$LANG('1493', '已成功下推销售应收单，请到销售应收单界面中查看') ,
                                type: 'success'
                            })
                            this.qryTabData() 
                        }else{
                            this.promptWin =true
                            this.prompt =this.$LANG('1446', '下推失败！')+res.result
                        }
                    })
    
                }).catch(err=>{})
            }
        },
        itemClick(val){
            this.actitem =val     
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY' ||column.property==='AMT'||column.property==='PCQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        }, 
        getFootSum(){
            let v_foot ={}
            const targetKeys = [ 'AMT','QTY' ]
            // 初始化累加器对象
            const initialAcc = targetKeys.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, {})
            // 单次 reduce 计算所有总和
            const totals = this.tabData.reduce((acc, cur) => {
                targetKeys.forEach(key => {
                    // 累加当前 key 的值，处理 undefined/null 情况
                    acc[key] += Number(cur[key]) || 0
                });
                return acc
            }, initialAcc)
            // 格式化并赋值
            targetKeys.forEach(key => {
                const val = totals[key];
                v_foot[key] = val > 0 ? val.toLocaleString() : '';
            })
            let v_obj =Object.assign({
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                }, v_foot)
            this.footerData =[  v_obj ]

        } , 
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/report/GenExcel',
                    data: {p_idseq:'123',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'销售单'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0509', '销售单')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)

                })
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            } 
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        //对指定列进行合计
        getTabSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =this.allData.map(item=>Number(item[column.property]));
                if(column.property==='QTY' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.qryTabData()
        } ,
 
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,IMGPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择正确的图片或PDF格式 ')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + this.$LANG('1561', ' 文件太大, 不能超出')+'8M'
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                 
        },
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='QTY' ){
                let v_amt=0
                if ( row['QTY'] && row['PRC']){
                    v_amt =(Number(row['QTY'])*Number( row['PRC'] )).toFixed(2)
                }
                this.dtlData.splice(index,1, Object.assign(row,{ AMT: v_amt} ))
            
            }
            this.$forceUpdate()
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'QTY'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                let v_prc =''
                if (this.mainRow['CRCY']== '4238') { //人民币
                    v_prc =obj['PRC']
                }else{
                    v_prc =obj['OUTPRC']
                }
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],PRC:v_prc,MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM'],RATE:obj['TAXNUM']} ))
                this.$refs['pos'+ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
 
            } 
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key =='ORDNO'){ // 销售订单
                this.v_table ='v_orditm'
                this.tableCol =this.ordCol
                this.v_key2 ='ordstfg'
                this.v_value2 ='Y'
                this.btnWin =true
            }else if (key=='MATNO'){
                if (row['MATTY']){
                    this.v_tabRow =row
                    this.v_tabIndex =index
                    this.v_table ='v_bs_mat'
                    this.tableCol =this.prodCol
                    this.v_key2 ='modelno'
                    this.v_value2 = row['MATTY']
                    this.btnWin =true
                }else{
                    this.prompt =this.$LANG('1735', '请选择物品类别')
                    this.promptWin =true
                }
            }
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
 
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
             
            }
 
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        getFeeData(idseq){
            this.feeData=[]
            getTabColOrData(this.v_url, 'V_ordfee','idseq',idseq).then((res) => {
                this.feeData =res.result
                this.$nextTick(()=>{
                    this.$refs['reffee'].doLayout()
                })
            })
        },
        accOk(id,val){
            this.feeRow['ACNO']=id
            this.feeRow['ACNM']=val
            this.accWin=false
        },
        feeSure(){
            if (!this.feeRow['FEENO']){
                this.promptWin=true
                this.prompt=this.$LANG('0394', '费用')+this.$LANG('0415', '项目')+this.$LANG('2051', '不能为空')
            }else{
                this.feeWin =false
                if (this.feeFlag==='edit' ){ //编辑时要替换数组记录
                    this.feeData.splice(this.feeIndex,1,this.feeRow)
                }else{
                    this.feeData.push(this.feeRow)
                }
            }
        },
        feeAdd(){
            this.feeRow={QTY:1,LSTSEQ:''}
            this.feeFlag='create'
            this.feeWin=true
        },
        feeEdit(row ,index){
            this.feeRow=JSON.parse(JSON.stringify(row))
            this.feeWin=true
            this.feeFlag='edit'
            this.feeIndex=index
        } ,
        feeDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此费用记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.feeData.splice(index,1)
                this.delFee.push(row)
            }).catch(()=>{})
        },
        //明细下拉框改变事件
        selChg(key,val,arr){    
            if (key=='ORDTY'){ //订单类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.dtlRow,{'ORDTYNM':item['CNAME']})
                    }
                })
            }else if (key=='FEENO'){ //费用类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.feeRow,{'FEENM':item['CNAME']})
                    }
                })
            }
        },
        feeAmt(key){
            if (key=='PRC'||key=='NOPRC'||key=='QTY'||key=='RATE'){
                var v_rate=Number(this.feeRow['RATE'])
                if (key=='RATE'||key =='PRC'){
                    this.feeRow['NOPRC'] =(Number(this.feeRow['PRC'])*(100-Number(v_rate))/100).toFixed(3 )
                }
                this.feeRow['AMT']=(Number(this.feeRow['QTY'])*Number(this.feeRow['PRC'])).toFixed(2)
            }
        },
        accChoose(){
            this.accWin=true
        },
 
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
            
        },
        dtlClick(row){
            this.chkIndex =row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        perDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此销售记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        saleAdd(){
 
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row={'MATTY':'PRD','ORDTY':'399847','ORDTYNM':'正式订单' }
            this.dtlData.push(v_row)
 
            this.$nextTick(()=>{
                this.$refs['refsale'].doLayout()
            }) 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'123',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录 
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            const v_arr  =Array.from(new Set(this.dtlData.map(item=>item.MATNO))) 
            if (this.dtlData.length>0 && v_arr.length<this.dtlData.length ){
                this.promptWin =true
                this.prompt =this.$LANG('1921', '明细记录中已存在相同的产品编码，请核查')
            }else {
                //发起保存请求   
                if (this.stfgBool && this.saveTag ) {    
                    this.saveTag =false
                    let obj_ ={},amt_=0,actamt_=0
                    //汇总明细金额
                    if(this.dtlData.length>0){
                        for(let k=0;k<this.dtlData.length;k++){
                            if(this.dtlData[k]['AMT']){
                                amt_=Number(amt_)+Number(this.dtlData[k]['AMT'])
                            }
                        }
                        for(let k=0;k<this.feeData.length;k++){
                            if(this.feeData[k]['AMT']){
                                amt_=Number(amt_)+Number(this.feeData[k]['AMT'])
                            }
                        }
                    }
                    //应收金额
                    if(this.mainRow['DISFEE']) {
                        actamt_=Number(amt_)-Number(this.mainRow['DISFEE'])
                    }else{
                        actamt_=Number(amt_)
                    }    
                    Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid,AMT:amt_.toFixed(2),ACTFEE:actamt_.toFixed(2)}) 
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'ord',frmid:'123'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //销售明细保存：批量保存  
                            this.$axios({   
                                method: 'post',
                                url: 'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'orditm',p_idseq:idseq_,p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            })
                            //明细删除
                            if (this.delArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url: 'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delArr), p_table:'orditm',p_idseq:idseq_,p_action:'D' },
                                })
                            }   
                            //费用明细保存：批量保存 
                            this.$axios({   
                                method: 'post',
                                url: 'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.feeData), p_table:'ordfee',p_idseq:idseq_,p_action:'S' },
                            })  
                            //明细删除
                            if (this.delFee.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url: 'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delFee), p_table:'ordfee',p_idseq:idseq_,p_action:'D' },
                                })
                            } 
                            //3、图片保存
                            for(var k=0;k<this.imgData.length;k++){
                                this.$axios({
                                    method: 'post',
                                    url: 'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                                })
                            }  
                            //图片删除处理
                            for(let k=0;k<this.delImg.length;k++){
                                let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                                }).then(res=>{          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                })   
                            }   
                            this.delImg=[]
                            vm.drawer =false   
                            vm.qryTabData()
                            
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                } 
            }
        },
        stfgSure(){
            if (this.v_stfg=='A' && !this.v_rmk){
                this.promptWin =true
                this.prompt ='当状态为异常关闭时，请输入备注'
                return
            }
            this.loadWin =true
            if (this.v_stfg =='A'){ //发起异常关闭
                // 调用工作流启动函数
                startWorkflowInstance({
                    flowId: '487446',
                    businessId: this.v_batRow.IDSEQ, // 使用文件ID作为业务单据ID
                    actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                    component: this,
                    axios: this.$axios,
                    baseUrl:  '',
                    // 微信消息相关参数
                    docType: '销售订单', // 单据类型
                    DIRNM: this.v_batRow.CLNTNM, // 项目名称，使用文件名
                    CNAME: this.v_batRow.PRDDESC,
                    businessData: {
                        flowType: 3,
                        qty: null,
                        amt: '100',
                    },
                    jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                })
                //this.loadWin =false
            }
            let v_rmk =this.v_rmk ||'' 
            let v_cond=' set stfg=\''+this.v_stfg +'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\',stfgrmk=\''+v_rmk+'\''
            this.$axios({
                method: 'post',
                url: 'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_batRow['IDSEQ'] ,p_table:'orditm',p_cond: v_cond},
            }).then(res=>{  
                this.stfgWin =false
                this.qryTabData()
                this.loadWin =false
            }) 
    
            
        },
 
        //状态审核
        recSet(row,val,text){
            let v_bool =false
            if( text=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户：')+row['CHKUSER']+this.$LANG('1646', ' 不同时不能弃审')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+text+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox', 
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    var vm=this,v_cond='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser='' 
                    if (val =='K') {
                        if(text=='弃审'){
                            v_cfmdttm =''
                            v_cfmuser =''
                        }else{
                            v_cfmdttm =getDate('full')
                            v_cfmuser =this.v_usernm
                        }
                        v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                    }else if (val =='Y'){
                        v_chkdttm =getDate('full')
                        v_chkuser =this.v_usernm
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                    }else{
                        v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
                    }
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ord',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.qryTabData()     
                        }else{
                            this.promptWin=true
                            this.prompt=res.message
                        }        
                    }) 
                    //发起审批时
                    if (val =='K'){
                        // 调用工作流启动函数
                        startWorkflowInstance({
                            flowId: '123',
                            businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                            actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                            component: this,
                            axios: this.$axios,
                            baseUrl:  '',
                            // 微信消息相关参数
                            docType: '销售订单', // 单据类型
                            DIRNM: row.CLNTNM, // 项目名称，使用文件名
                            CNAME: row.PRDDESC,
                            businessData: {
                                flowType: 3,
                                qty: null,
                                amt: row['TTLAMT'],
                            },
                            jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                        })
                    }else if( text=='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                        this.$axios({
                            method: 'post',
                            url: 'xuper_auth/updateRec',
                            data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                        }).then(res=>{
                            // 在日志表中 插入 一条 弃认记录
                            let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃认'}
                            this.$axios({
                                method: 'post',
                                url: 'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                            }).then(res=>{   
                            })
                        })
                    }else if( text=='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                            this.$axios({
                                method: 'post',
                                url: 'xuper_auth/updateRec',
                                data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                            }).then(res=>{
                                // 在日志表中 插入 一条 弃认记录
                                let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃审'}
                                this.$axios({
                                    method: 'post',
                                    url: 'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                }).then(res=>{   
                                })
                            })
                    }
                }).catch(()=>{})
            }
        },

        //订单明细
        getOrdList(cond){
            this.loadingInstance.show()  
            let v_cond=''   
            if (this.othBool){
                v_cond =' and adduser=\''+this.v_usernm+'\''
            }
            if (this.v_isfin!=='ALL'){
                v_cond =v_cond +' and isfin=\''+this.v_isfin+'\''
            } 
            this.$axios({   
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: {p_key:'ordty', p_value:'ORD',p_key2:'corpid', p_value2:this.v_corpid,p_cond:v_cond+cond+' order by '+this.selparam+' desc',p_table:'V_ord'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.getFootSum()
                        this.loadingInstance.close() 
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }              
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData =[]
            getTabColOrData(this.v_url, 'V_orditm','idseq',idseq).then((res) => {
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refsale'].doLayout()
                })
    
            })
        },
 
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
 
                    this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
               
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex=index
            this.tabData = this.allData.slice(_start,_end)
            this.getFootSum()
        },
        selRec(row){

        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFGNM==='待审核'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true 
            this.saveTag =true
            this.delArr =[]
            this.getDtlData(row.IDSEQ)
            this.getFeeData(row.IDSEQ)      
            this.qryImgData(row.IDSEQ)      
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let v_cond ='' , v_oper='' ,v_edcss='' ,cond_=''
            if (this.selparam ){ //列1
                this.tabArr.some(item=>{  
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and  '+item + v_oper +'\''+this.v_row[item] +'\''          
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''  
                        }
                    }
                }
            })
            //console.log(v_cond)
            this.getOrdList( v_cond)
        },
        //新增客户
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={ORDDTTM:getDate('day'),STAFFNM:this.v_usernm,CRCY:'4238',STFG:'N',ISTAX:'Y',CHKTY:'425800'}
            this.saveFlag=false
            this.dtlData=[]
            this.delImg =[]
            this.imgData=[] 
            this.feeData=[]
            this.saveTag =true
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
        //查询附件数据
        qryImgData(idseq){
            getTabColOrData(this.v_url, 'V_mat_img','idseq',idseq,'','').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //获取表列字段
        getTabField(){
            let vm =this
            this.vueCol =[]
            getTabColOrData(vm.v_url,'v_sys_form_fld','idseq','123','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then((res) => {
                this.vueCol =[]
                this.tabArr =[]
                const mainFields =this.sortFieldRows(res.result)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        sortable:rowField.SORTABLE,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='number') {
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <input  disabled={itcol.EDCSS=='image'}  value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)}  on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                            </div>
                                        </div>                                   
                                    )}else if ( itcol.key=='STFG'){
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex" >
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                        <el-option  value="Y" label={this.$LANG('1976', '已审核')} ></el-option>
                                                        <el-option  value="P"  label={this.$LANG('1961', '审核中')} ></el-option>
                                                        <el-option  value="K"  label={this.$LANG('1982', '已确认')} ></el-option>
                                                        <el-option  value="N"  label={this.$LANG('2005', '未审核')} ></el-option>
                                                    </el-select>                                                          
                                                </div>
                                            </div>                                   
                                        )    
                                    }else if ( itcol.key =='SEL'){
                                        return (                              
                                            <div >                   
                                                <div style="display:flex;height:28px;"> 
                                                    <el-checkbox v-model={this.v_row['SEL']} true-label="Y" false-label="N" size="small"  style="width:100%" on-change={()=>this.chkChg() }  ></el-checkbox>                                                           
                                                </div>
                                            </div>                    
                                        )    
                                    }else if ( itcol.key =='MODIFY'){
                                        return (                              
                                            <div >                   
                                            </div>                    
                                        )    
                                    }else if (itcol.key=='ISFIN' ){
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex" >
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                        <el-option  value="Y" label={this.$LANG('2047', '是')} ></el-option>
                                                        <el-option  value="N"  label={this.$LANG('2044', '否')} ></el-option>
                                                        <el-option  value="A"  label={this.$LANG('2141', '关闭')} ></el-option>
                                                    </el-select>                                                          
                                                </div>
                                            </div>                                   
                                        )    
                                    }else if (itcol.EDCSS=='checkbox' ){
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex" >
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                        <el-option  value="Y" label={this.$LANG('2047', '是')} ></el-option>
                                                        <el-option  value="N"  label={this.$LANG('2044', '否')} ></el-option>
                                                    </el-select>                                                          
                                                </div>
                                            </div>                                   
                                        )    
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <input  disabled={itcol.EDCSS=='image'||itcol.key=='SEL'}  value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)}  on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }
                             
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                }else if (itcol.key=='SEL' ){
                                    return ( 
                                        <el-checkbox true-label="Y" disabled={row['STFG']!=='Y'} false-label="N" v-model={row['SEL']}  style="width:100%;"   > </el-checkbox>
                                    )
                                }else if (itcol.key=='MODIFY' ){
                                    return ( 
                                        <el-link  disabled={row['STFG']!=='Y'} underline={false} on-click={()=>{this.batStfg( row)}} style="width:100%;border-bottom:1px solid #409eff"> 变更</el-link>
                                    )
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='P'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag> )
                                    }else if (row[itcol['key']] =='K'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1982', '已确认')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                }  else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else if (row[itcol['key']] =='A'){
                                        return (<el-tag   size="mini" type="danger" effect="dark">{this.$LANG('2141', '关闭')}</el-tag> )
                                    }  
                                    else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:200,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'K', '确认')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0364', '确认')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'X','作废')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        }else if (row['STFG'] =='P') {
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
 
                                </div>                                
                            )  
                        }else if (row['STFG']=='K'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.recSet(row,'N', '弃认')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0314', '弃认')}</span></el-link>
                 
                                </div>                                
                            )
                        }else if (row['STFG']=='Y'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'N','弃审')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
 
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            // <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
            // <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'Y','审核')}}  underline={false} ><span style="font-size:12px;margin-right:5px">审核</span></el-link>
            getTabColOrData(vm.v_url,'v_sys_form_fld','idseq','123','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(vm.v_url,'v_sys_form_fld','idseq','123','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.feeCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(vm.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        height:20px;
    }
 
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
</style>
<style lang="less">
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
        height:20px !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .el-date-editor .el-input__inner {
        padding-left: 28px;
        padding-right:0px;

    }
</style>
